module.exports = "/virtual-football-league/img/amblems/right/logos/Fake_Arsenal.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Fake_Arsenal.png
// module id = 2179
// module chunks = 4